import PMDashboardPage from '../pages/PMDashboard';

const PMdashboardRoute = {
  public: [],
  auth: [
    {
      name: 'PM Dashboard',
      path: '/pm-dashboard',
      permissions: [],
      component: PMDashboardPage,
    },
  ],
};

export default PMdashboardRoute;
